import { MessageBox } from 'components';

interface EmptyReportDataMessageProps {
  title?: string;
  tagline?: string;
}

const EmptyReportDataMessage = ({ title, tagline }: EmptyReportDataMessageProps) => (
  <MessageBox title={title || 'No report is associated with this company yet'} tagline={tagline || 'Please add a report date first'} fullWidth={false} />
);

export default EmptyReportDataMessage;
